import React, { useState, useEffect } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  IconButton,
  Box,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
const NonOrderPartiesTable = ({
  nonOrderParties,
  nonOrderPartiesCount,
  startDate,
  endDate,
  salesperson
}) => {
  const [loader, setLoader] = useState(false);
  const [downloadStatus, setDownloadStatus] = useState(null);
  const createAndDownloadPdf = () => {
    //(rows);
    //(filteredRows);
    setLoader(true);
    if (nonOrderParties.length) {
      setDownloadStatus("loading");
      axios
        .post(`${process.env.REACT_APP_API}/create-report2`, {
            nonOrderParties,
            nonOrderPartiesCount,
            startDate,
            endDate,
            salesperson
        })
        .then(() =>
          axios.get(`${process.env.REACT_APP_API}/fetch-report2`, {
            responseType: "blob",
          })
        )
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          // const downloadUrl = window.URL.createObjectURL(pdfBlob);
          // setDownloadStatus("success");
          // window.open(downloadUrl, "_blank");
          const currentDate = new Date();

          saveAs(pdfBlob, `NonOrderPartiesReport${currentDate}.pdf`);
          // const downloadUrl = `https://orders.sadhanaayurvedics.com/files/Exported-NonOrderPartiesReport/report.pdf`;
          const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-NonOrderPartiesReport/report.pdf`;
          window.open(downloadUrl, "_blank");
          setLoader(false);
          setDownloadStatus("success");
        });
    } else {
      alert("No record to Export");
    }
  };
  return (
    <TableContainer component={Paper} elevation={0}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="right">
              <div style={{ display: "flex", alignItems: "center" ,justifyContent:"space-between"}}>
                <span>Count: {nonOrderPartiesCount}</span>
                {loader ? (
                  <CircularProgress style={{ marginLeft: "10px" }} />
                ) : (
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadPdf}
                    style={{
                      marginLeft: "10px",
                    }}
                  >
                    PDF
                  </Button>
                )}
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Non Order Parties Name </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {nonOrderParties.map((party, index) => (
            <TableRow key={index}>
              <TableCell>{party}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NonOrderPartiesTable;
